import { FunctionComponent, useCallback, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { IFilter } from '@knowmax/genericlist-core'
import { useGenericListSettings, fieldIdForOperator, getParamId } from '@knowmax/genericlist-core'

/** Renders filter with renderCustom property set. */
export const FilterCustom: FunctionComponent<{ filter: IFilter, listId?: string }> = observer(({ filter, listId }) => {
  const settings = useGenericListSettings()

  const filterparamid = useMemo(() => getParamId(filter.id, listId), [filter.id, listId])

  const selected = useMemo(() => {
    return settings.params.get(filterparamid) ?? undefined
  }, [filter, settings.params])

  const select = useCallback((value?: string) => {
    const params = new URLSearchParams(settings.params)
    params.delete(filterparamid)

    if (value && value !== '') {
      params.set(filterparamid, value);
    } else {
      params.delete(fieldIdForOperator(filterparamid))
    }

    settings.serialize(params)
  }, [filter, settings.params, filterparamid])

  return (
    <>
      {filter.renderCustom &&
        <>          
          {filter.renderCustom(filter, selected, select, listId)}
        </>
      }
    </>
  )
})